import { useState, useMemo } from "react";
import { CSVLink } from "react-csv";

const BotonFlotante = ({
  opciones = [],
  data = [],
  headers = [],
  nombreArchivo = "exportacion",
  ocultarBoton = false
}) => {
  const [menuAbierto, setMenuAbierto] = useState(false);

  const toggleMenu = () => setMenuAbierto(!menuAbierto);
  const cerrarMenu = () => setMenuAbierto(false);
  const opcionesFinales = [
    {
      texto: "Exportar Excel",
      icono: "📂",
      esCSV: true,
    },
    ...opciones
  ];

  const estilos = useMemo(() => ({
    botonPrincipal: {
      position: "fixed",
      bottom: "20px",
      right: "20px",
      width: "60px",
      height: "60px",
      borderRadius: "50%",
      backgroundColor: "#ff4747",
      color: "white",
      border: "none",
      fontSize: "24px",
      fontWeight: "bold",
      cursor: "pointer",
      boxShadow: "0 6px 14px rgba(0, 0, 0, 0.25), 0 4px 6px rgba(0, 0, 0, 0.2)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
      transition: "all 0.3s",
      transform: menuAbierto ? "rotate(45deg)" : "rotate(0deg)",
      outline: "none"
    },
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: 998,
      display: menuAbierto ? "block" : "none"
    },
    menu: {
      position: "fixed",
      bottom: "90px",
      right: "20px",
      display: menuAbierto ? "flex" : "none",
      flexDirection: "column-reverse",
      gap: "8px",
      zIndex: 999
    },
    opcion: {
      padding: "10px 16px",
      backgroundColor: "white",
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
      cursor: "pointer",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
      fontSize: "14px",
      color: "#333",
      whiteSpace: "nowrap",
      transition: "all 0.2s ease",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      minWidth: "150px"
    }
  }), [menuAbierto]);

  return (
    <>
      <div style={estilos.overlay} onClick={cerrarMenu} />

      <div style={estilos.menu}>
        {opcionesFinales.map((opcion, index) =>
          opcion.esCSV ? (
            <CSVLink
              key={index}
              data={data}
              headers={headers}
              filename={`${nombreArchivo}.csv`}
              separator=";"
              style={estilos.opcion}
              onClick={cerrarMenu}
            >
              <span>{opcion.icono}</span> {opcion.texto}
            </CSVLink>
          ) : (
            <button
              key={index}
              style={estilos.opcion}
              onClick={() => {
                opcion.accion();
                cerrarMenu();
              }}
            >
              <span>{opcion.icono}</span> {opcion.texto}
            </button>
          )
        )}
      </div>

      {!ocultarBoton && (
        <button style={estilos.botonPrincipal} onClick={toggleMenu}>
          +
        </button>
      )}
    </>
  );
};

export default BotonFlotante;
